/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {
    "use strict";

    export class AboutDealerwareController {
        public static $inject: string[] = [
            'AppConfig',
            '$mobilityCompanyAuthentication',
            'DataUtils',
            '$mdDialog'
        ];

        public optimizations: any[] = [];
        public integrations: string[] = [];

        constructor(public appConfig: any,
                    public auth: any,
                    public DataUtils: any,
                    public $mdDialog: any) {
            var dataUtils = this.DataUtils.getInstance(),
                location = this.auth.location;

            if (!location) { return; }

            if (location.has_ccs) {
                this.optimizations.push({
                    name: 'Connected Car Devices',
                    image: '/images/car-device-icon.png'
                });
            }

            if (location.has_tolls) {
                this.optimizations.push({
                    name: 'Toll Management Service',
                    image: '/images/toll-icon.png'
                });
            }

            if (!dataUtils.isBlank(location.settings.dms_provider)) {
                this.integrations.push('Dealer Management System');
            }

            if (location.settings.my_kaarma) {
                this.integrations.push('myKaarma');
            }
        }

        public get currentYear() : string {
            return moment().format('YYYY');
        }

        public closeModal() : void {
            this.$mdDialog.hide();
        }
    }

    getDealerwareWebContentModule().controller('AboutDealerwareController', AboutDealerwareController);
}
